import { render, staticRenderFns } from "./PrkDescription.vue?vue&type=template&id=81456628&scoped=true&"
import script from "./PrkDescription.vue?vue&type=script&lang=js&"
export * from "./PrkDescription.vue?vue&type=script&lang=js&"
import style0 from "./PrkDescription.vue?vue&type=style&index=0&id=81456628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81456628",
  null
  
)

export default component.exports